/**
 * How checkout names the membership that covers a staged seat:
 * "Scale membership", from the company's effective stage
 * (`userAppSettings.companyStage.name`). "Stage Growth" is the Salesforce
 * product name, not something members recognise, so it never appears.
 */
export function stageMembershipLabel(
  stageName: string | null | undefined,
): string {
  const name = stageName?.trim();
  return name ? `${name} membership` : "stage membership";
}
